import { baseCMSApi } from '@/shared/api/base-cms-api';
import { CMS_ENDPOINTS } from '@/shared/api/endpoints';

import type { Reviews } from '../model/types/reviews';

const reviewsApi = baseCMSApi
    .enhanceEndpoints({
        addTagTypes: ['Reviews'],
    })
    .injectEndpoints({
        endpoints: (build) => ({
            getReviewsContent: build.query<Reviews, { locale: string }>({
                query: (params) => ({
                    url: CMS_ENDPOINTS.getReviewForm(),
                    method: 'GET',
                    params: {
                        locale: params.locale,
                        depth: 1,
                    },
                }),

                providesTags: ['Reviews'],
            }),
        }),
    });

export const { useGetReviewsContentQuery } = reviewsApi;
